import axios from './http';
import { getAccessToken } from 'services/browserStorageServices';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;

export const fetchMessages = async (): Promise<Object> => {

  let allMessages = await axios.get(`${baseUrl}/public/api/text-messages`).then(response => response.data);
  if (getAccessToken()) {
    try {
      const privateMessages = await axios.get(`${baseUrl}/api/text-messages`).then(response => response.data);
      allMessages = {...allMessages, ...privateMessages};
    } catch (e) {
      // do nothing; might happen that access token is present, but expired.
    }
  }
  return allMessages;
};
